import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StaffPageShell from '../components/StaffPageShell';
import { mastersAPI } from '../services/api';

const MASTER_SECTIONS = [
  { key: 'role', label: 'Roles' },
  { key: 'company', label: 'Companies' },
  { key: 'course', label: 'Courses' },
  { key: 'degree', label: 'Degrees' },
  { key: 'university', label: 'Universities / Colleges' },
];

function formatMasterItem(item) {
  if (item == null) return '';
  if (typeof item === 'string' || typeof item === 'number') return String(item);
  if (typeof item === 'object') {
    return (
      item.value ??
      item.companyName ??
      item.courseName ??
      item.label ??
      item.name ??
      item.id ??
      ''
    );
  }
  return String(item);
}

const MasterDropdownPage = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMasters = async () => {
      setLoading(true);
      setError('');
      try {
        const responses = await Promise.all(
          MASTER_SECTIONS.map((section) => mastersAPI.list(section.key))
        );

        const result = {};
        MASTER_SECTIONS.forEach((section, i) => {
          const payload = responses[i].data;
          result[section.key] = Array.isArray(payload) ? payload : [];
        });

        setData(result);
      } catch (err) {
        console.error('Failed to load master data:', err);
        setError(err.response?.data?.message || 'Failed to load master data');
      } finally {
        setLoading(false);
      }
    };

    fetchMasters();
  }, []);

  return (
    <StaffPageShell
      title="Master Data"
      subtitle="Reference lists used across forms and filters. Training centers (Location of Center) are edited on their own page."
    >
      <p className="text-sm mb-4">
        <Link to="/admin/training-centers" className="underline" style={{ color: 'var(--color-primary)' }}>
          Add or edit training centers
        </Link>
        {' — '}
        shared Location of Center for Add User, batches, courses, and filters.
      </p>

      {error && (
        <div
          className="mb-4 p-3 rounded-lg text-sm"
          style={{ backgroundColor: 'var(--color-error-100)', color: 'var(--color-error)' }}
        >
          {error}
        </div>
      )}

      {loading ? (
        <p className="theme-text">Loading…</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {MASTER_SECTIONS.map((section) => {
            const items = data[section.key] || [];
            return (
              <div
                key={section.key}
                className="rounded-lg p-4 border"
                style={{
                  borderColor: 'var(--color-border)',
                  backgroundColor: 'var(--color-surface)',
                }}
              >
                <h2 className="font-semibold text-lg mb-2 theme-text">{section.label}</h2>
                <p className="text-xs theme-text-secondary mb-3">{items.length} items</p>
                <ul className="list-disc list-inside space-y-1 theme-text max-h-64 overflow-y-auto">
                  {items.length === 0 ? (
                    <li className="theme-text-secondary">No values</li>
                  ) : (
                    items.map((item, idx) => (
                      <li key={item?.id ?? `${section.key}-${idx}`}>
                        {formatMasterItem(item)}
                      </li>
                    ))
                  )}
                </ul>
              </div>
            );
          })}
        </div>
      )}
    </StaffPageShell>
  );
};

export default MasterDropdownPage;
